/* =============================================
   FWG Café Equipment Wraps — Inquiry Form
   Assets: fwg-cafe-form.js
   ============================================= */

var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

/* ── Constants ── */
var TOTAL_STEPS = 4;
var currentStep = 1;
var completedSteps = new Set();

/* ── Equipment Config ── */
var EQUIP_TYPES = {
  espresso_machine: { label: 'Espresso Machine', placeholder: 'e.g. La Marzocco Linea Classic S 3 Group' },
  drip_brewer:      { label: 'Drip Brewer',      placeholder: 'e.g. Fetco CBS-2242' },
  bean_grinder:     { label: 'Bean Grinder',      placeholder: 'e.g. Mazzer Super Jolly V Pro' },
  milk_steamer:     { label: 'Milk Steamer',      placeholder: 'e.g. La Marzocco Wally' },
  other:            { label: 'Other Equipment',   placeholder: 'e.g. Display refrigerator, ice machine, POS terminal' }
};

/* ── Service Area States ── */
var SERVICE_STATES = [
  'Maryland',
  'Washington, D.C.',
  'Virginia',
  'West Virginia',
  'Delaware',
  'Pennsylvania'
];

/* ── Populate State Dropdown ── */
function populateStates() {
  var sel = document.getElementById('cafeState');
  if (!sel) return;
  SERVICE_STATES.forEach(function(st) {
    var opt = document.createElement('option');
    opt.value = st;
    opt.textContent = st;
    sel.appendChild(opt);
  });
}

/* ── Stepper Navigation ── */
function goToStep(target) {
  if (target < 1 || target > TOTAL_STEPS || target === currentStep) return;
  var isForward = target > currentStep;
  if (isForward) {
    for (var s = currentStep; s < target; s++) {
      var errors = getStepErrors(s);
      if (errors.length > 0) {
        highlightErrors(s, errors);
        showToast('Please fill in all required fields');
        return;
      }
      completedSteps.add(s);
    }
  }
  if (!isForward && getStepErrors(currentStep).length === 0) {
    completedSteps.add(currentStep);
  }
  switchCard(target);
}

function switchCard(target) {
  var currentCard = document.querySelector('.form-page-cafe .step-card[data-step="' + currentStep + '"]');
  if (currentCard) currentCard.classList.remove('active');
  if (target === TOTAL_STEPS) buildSummary();
  var targetCard = document.querySelector('.form-page-cafe .step-card[data-step="' + target + '"]');
  if (targetCard) {
    void targetCard.offsetWidth;
    targetCard.classList.add('active');
  }
  currentStep = target;
  updateStepper();
  var stepper = document.getElementById('cafeStepper');
  if (stepper) {
    stepper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/* ── Validation ── */
function getStepErrors(stepNum) {
  var errors = [];
  switch (stepNum) {
    case 1:
      if (!document.getElementById('cafeName').value.trim()) errors.push('cafeName');
      if (!document.getElementById('cafeEmail').value.trim()) errors.push('cafeEmail');
      if (!document.getElementById('cafePhone').value.trim()) errors.push('cafePhone');
      if (!document.getElementById('cafeContactMethodHidden').value) errors.push('contactMethod');
      break;
    case 2:
      if (!document.getElementById('cafeEquipHidden').value) errors.push('equipType');
      if (!document.getElementById('cafeCity').value.trim()) errors.push('cafeCity');
      if (!document.getElementById('cafeState').value) errors.push('cafeState');
      break;
    case 3:
      if (!document.getElementById('cafeBrandHidden').value) errors.push('brandStatus');
      if (!document.getElementById('cafeDeliveryHidden').value) errors.push('delivery');
      if (!document.getElementById('cafeTimeline').value) errors.push('cafeTimeline');
      break;
  }
  return errors;
}

function highlightErrors(stepNum, errors) {
  document.querySelectorAll('.form-page-cafe .field-error').forEach(function(el) { el.classList.remove('field-error'); });
  var card = document.querySelector('.form-page-cafe .step-card[data-step="' + stepNum + '"]');
  if (!card) return;
  card.classList.remove('shake');
  void card.offsetWidth;
  card.classList.add('shake');
  errors.forEach(function(errKey) {
    switch(errKey) {
      case 'cafeName': case 'cafeEmail': case 'cafePhone':
        var el = document.getElementById(errKey);
        if (el) el.closest('.field-group').classList.add('field-error');
        break;
      case 'contactMethod':
        var cm = document.querySelector('.form-page-cafe .contact-method-group');
        if (cm) cm.closest('.field-group').classList.add('field-error');
        break;
      case 'equipType':
        var eg = document.querySelector('.form-page-cafe .equip-type-grid');
        if (eg) eg.closest('.field-group').classList.add('field-error');
        break;
      case 'cafeCity': case 'cafeState': case 'cafeTimeline':
        var fel = document.getElementById(errKey);
        if (fel) fel.closest('.field-group').classList.add('field-error');
        break;
      case 'brandStatus':
        var bg = document.querySelector('.form-page-cafe .brand-btn-group');
        if (bg) bg.closest('.field-group').classList.add('field-error');
        break;
      case 'delivery':
        var dg = document.querySelector('.form-page-cafe .delivery-btn-group');
        if (dg) dg.closest('.field-group').classList.add('field-error');
        break;
    }
  });
}

document.addEventListener('input', function() {
  document.querySelectorAll('.form-page-cafe .field-error').forEach(function(el) { el.classList.remove('field-error'); });
});
document.addEventListener('click', function(e) {
  if (e.target.closest('.form-page-cafe .contact-method-btn, .form-page-cafe .equip-type-btn, .form-page-cafe .brand-btn, .form-page-cafe .delivery-btn')) {
    document.querySelectorAll('.form-page-cafe .field-error').forEach(function(el) { el.classList.remove('field-error'); });
  }
});

function updateStepper() {
  document.querySelectorAll('.form-page-cafe .step-indicator').forEach(function(ind) {
    var step = parseInt(ind.dataset.step);
    ind.classList.remove('active', 'completed');
    if (step === currentStep) {
      ind.classList.add('active');
    } else if (completedSteps.has(step)) {
      ind.classList.add('completed');
    }
  });
}

/* ── Label Maps ── */
var brandLabels = {
  ready: 'Ready to use',
  needs_adjustments: 'Needs adjustments',
  need_design: 'Need design support'
};
var deliveryLabels = {
  deliver_to_fwg: 'Delivered to FWG',
  vendor_coordination: 'Vendor coordination',
  onsite: 'On-site wrap',
  not_sure: 'Not sure yet'
};
var timelineLabels = {
  asap: 'ASAP / As soon as possible',
  '30_days': 'Within 30 days',
  '30_60_days': '30\u201360 days',
  '60_90_days': '60\u201390+ days',
  planning: 'Just planning / gathering info'
};

/* ── Contact Method ── */
function selectContactMethod(btn) {
  document.querySelectorAll('.form-page-cafe .contact-method-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('cafeContactMethodHidden').value = btn.dataset.value;
}

/* ── Equipment Type (multi-select with per-item detail panels) ── */
function toggleEquipType(btn) {
  btn.classList.toggle('selected');
  var selected = [];
  document.querySelectorAll('.form-page-cafe .equip-type-btn.selected').forEach(function(b) { selected.push(b.dataset.value); });
  document.getElementById('cafeEquipHidden').value = selected.join(',');

  // Show/hide detail panels for each type
  Object.keys(EQUIP_TYPES).forEach(function(key) {
    var panel = document.getElementById('cafeEquipDetail_' + key);
    if (panel) {
      if (selected.indexOf(key) !== -1) {
        panel.classList.add('visible');
      } else {
        panel.classList.remove('visible');
      }
    }
  });
}

/* ── Brand Status ── */
function selectBrandStatus(btn) {
  document.querySelectorAll('.form-page-cafe .brand-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('cafeBrandHidden').value = btn.dataset.value;

  var uploadPanel = document.getElementById('cafeBrandUploadPanel');
  if (btn.dataset.value === 'ready' || btn.dataset.value === 'needs_adjustments') {
    uploadPanel.classList.add('visible');
  } else {
    uploadPanel.classList.remove('visible');
  }
}

/* ── Delivery Method ── */
function selectDelivery(btn) {
  document.querySelectorAll('.form-page-cafe .delivery-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('cafeDeliveryHidden').value = btn.dataset.value;
}

/* ── Phone Formatting ── */
function formatPhone(input) {
  var val = input.value.replace(/\D/g, '');
  if (val.length > 10) val = val.substring(0, 10);
  if (val.length >= 7) { input.value = '(' + val.substring(0,3) + ') ' + val.substring(3,6) + '-' + val.substring(6); }
  else if (val.length >= 4) { input.value = '(' + val.substring(0,3) + ') ' + val.substring(3); }
  else if (val.length > 0) { input.value = '(' + val; }
}

/* ── Build Equipment Data from Detail Panels ── */
function getEquipmentData() {
  var equipRaw = document.getElementById('cafeEquipHidden').value;
  if (!equipRaw) return [];
  var types = equipRaw.split(',');
  var items = [];
  types.forEach(function(key) {
    var modelInput = document.getElementById('cafeEquipModel_' + key);
    var qtySelect = document.getElementById('cafeEquipQty_' + key);
    items.push({
      type: key,
      label: EQUIP_TYPES[key] ? EQUIP_TYPES[key].label : key,
      model: modelInput ? modelInput.value.trim() : '',
      quantity: qtySelect ? qtySelect.value : '1'
    });
  });
  return items;
}

/* ── Review Summary ── */
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
function summaryRow(label, value) { return '<div class="summary__row"><span class="summary__label">' + label + '</span><span class="summary__value">' + (value || '<span style="color:#555;">\u2014</span>') + '</span></div>'; }
function editBtn(step) { return '<button type="button" class="btn-edit" onclick="goToStep(' + step + ')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>'; }
function sectionHeader(num, title, step) { return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">' + num + '</span> ' + title + '</div>' + editBtn(step) + '</div>'; }

function buildSummary() {
  var html = '';

  // 1. Contact
  html += '<div class="summary__section">' + sectionHeader('01', 'Contact Info', 1);
  html += summaryRow('Name', esc(document.getElementById('cafeName').value));
  var biz = document.getElementById('cafeBusiness').value.trim();
  if (biz) html += summaryRow('Business', esc(biz));
  html += summaryRow('Email', esc(document.getElementById('cafeEmail').value));
  html += summaryRow('Phone', esc(document.getElementById('cafePhone').value));
  var cm = document.getElementById('cafeContactMethodHidden').value;
  html += summaryRow('Preferred', cm === 'email' ? 'Email' : cm === 'text' ? 'Text' : cm === 'call' ? 'Call' : '');
  html += '</div>';

  // 2. Equipment & Location
  html += '<div class="summary__section">' + sectionHeader('02', 'Equipment & Location', 2);
  var items = getEquipmentData();
  items.forEach(function(item) {
    var desc = esc(item.label) + ' \u00D7 ' + esc(item.quantity);
    if (item.model) desc += ' \u2014 ' + esc(item.model);
    html += summaryRow(esc(item.label), desc);
  });
  html += summaryRow('Location', esc(document.getElementById('cafeCity').value) + ', ' + esc(document.getElementById('cafeState').value));
  html += '</div>';

  // 3. Brand, Design & Logistics
  html += '<div class="summary__section">' + sectionHeader('03', 'Brand & Logistics', 3);
  var brand = document.getElementById('cafeBrandHidden').value;
  html += summaryRow('Branding', brandLabels[brand] || brand);
  var vision = document.getElementById('cafeVision').value.trim();
  if (vision) html += summaryRow('Vision', esc(vision));
  var delivery = document.getElementById('cafeDeliveryHidden').value;
  html += summaryRow('Delivery', deliveryLabels[delivery] || delivery);
  var timeline = document.getElementById('cafeTimeline').value;
  html += summaryRow('Timeline', timelineLabels[timeline] || timeline);
  html += '</div>';

  document.getElementById('cafeSummaryContainer').innerHTML = html;
}

/* ── Toast ── */
function showToast(m) {
  var t = document.getElementById('cafeToast');
  t.textContent = m;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2200);
}

/* ── File Names Display ── */
function showFileNames(i, uid) {
  var el = document.querySelector('#' + uid + ' .file-names');
  el.textContent = i.files.length ? Array.from(i.files).map(function(f) { return f.name; }).join(', ') : '';
}

/* ── File Upload to Supabase ── */
function uploadFile(file, folder) {
  var timestamp = Date.now();
  var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  var path = folder + '/' + timestamp + '_' + safeName;
  return fetch(
    FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path,
    {
      method: 'POST',
      headers: {
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'x-upsert': 'true'
      },
      body: file
    }
  ).then(function(response) {
    if (!response.ok) {
      return response.text().then(function(t) { console.error('Upload failed:', file.name, t); return null; });
    }
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  });
}

function uploadFiles(fileInput, folder) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) return Promise.resolve([]);
  var promises = [];
  for (var i = 0; i < fileInput.files.length; i++) {
    promises.push(uploadFile(fileInput.files[i], folder));
  }
  return Promise.all(promises).then(function(urls) {
    return urls.filter(function(u) { return u !== null; });
  });
}

/* ── Submit Handler ── */
document.addEventListener('DOMContentLoaded', function() {

  populateStates();

  document.getElementById('fwgCafeForm').addEventListener('submit', function(e) {
    e.preventDefault();

    for (var i = 1; i <= TOTAL_STEPS; i++) {
      var errors = getStepErrors(i);
      if (errors.length > 0) {
        switchCard(i);
        (function(step, errs) {
          setTimeout(function() { highlightErrors(step, errs); }, 50);
        })(i, errors);
        showToast('Please fill in all required fields');
        return;
      }
    }

    var submitBtn = document.querySelector('.form-page-cafe .btn-submit');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Submitting...</span>';
    }

    var submissionId = Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var folder = 'submissions/' + submissionId;

    var equipPhotoInput = document.querySelector('input[name="cafe_equip_photos"]');
    var brandFileInput = document.querySelector('input[name="cafe_brand_files"]');
    var inspoInput = document.querySelector('input[name="cafe_inspo_images"]');

    var equipPhotoUrls = [];
    var brandFileUrls = [];
    var inspoUrls = [];

    uploadFiles(equipPhotoInput, folder + '/equipment_photos')
    .then(function(urls) {
      equipPhotoUrls = urls;
      return uploadFiles(brandFileInput, folder + '/brand_files');
    })
    .then(function(urls) {
      brandFileUrls = urls;
      return uploadFiles(inspoInput, folder + '/inspiration');
    })
    .then(function(urls) {
      inspoUrls = urls;

      var equipmentItems = getEquipmentData();

      var payload = {
        form_type: 'cafe_wrap',
        contact_name: document.getElementById('cafeName').value.trim(),
        business_name: document.getElementById('cafeBusiness').value.trim() || null,
        email: document.getElementById('cafeEmail').value.trim(),
        phone: document.getElementById('cafePhone').value.trim(),
        contact_method: document.getElementById('cafeContactMethodHidden').value,
        equipment: equipmentItems.map(function(item) {
          return {
            type: item.type,
            model: item.model || null,
            quantity: item.quantity
          };
        }),
        equipment_photo_urls: equipPhotoUrls,
        location: {
          city: document.getElementById('cafeCity').value.trim(),
          state: document.getElementById('cafeState').value
        },
        branding: {
          status: document.getElementById('cafeBrandHidden').value,
          file_urls: brandFileUrls,
          vision: document.getElementById('cafeVision').value.trim() || null
        },
        delivery_method: document.getElementById('cafeDeliveryHidden').value,
        timeline: document.getElementById('cafeTimeline').value,
        additional_info: (document.getElementById('cafeAdditionalInfo') || {}).value || null,
        reference_image_urls: inspoUrls,
        source_page: window.location.pathname,
        user_agent: navigator.userAgent
      };

      return fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(t) { throw new Error('Submission failed: ' + t); });
      }
      showToast('Quote request submitted!');
      setTimeout(function() {
        window.location.href = FWG_CONFIG.THANK_YOU_URL;
      }, 800);
    })
    .catch(function(err) {
      console.error('Form submission error:', err);
      showToast('Something went wrong. Please try again or call us directly.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  });

});
